export const management12th = [
  {
    id: 'jjeongii_12',
    name: '쩡이',
    role: '회장',
    department: '소프트웨어학과',
    generation: 12,
    img: '/jjeongii_12.jpg',
    github: 'https://github.com/jjeongee',
    rank: 'captain',
  },
  {
    id: 'loopy_12',
    name: '루피',
    role: '부회장',
    department: '소프트웨어학과',
    generation: 12,
    img: '/loopy_12.png',
    github: 'https://github.com/wonjeongjeong',
    rank: 'first-officer',
  },
  {
    id: 'vetel_12',
    name: '베텔',
    role: '운영진',
    department: '항공전자정보공학부',
    generation: 12,
    img: '/vetel_12.png',
    github: 'https://github.com/Vettel22',
    rank: 'senior-crew',
  },
  {
    id: 'ari_12',
    name: '아리',
    role: '운영진',
    department: '소프트웨어학과',
    generation: 12,
    img: '/ari_12.png',
    github: 'https://github.com/mcy0325',
    rank: 'senior-crew',
  },
];

export const management13th = [
  {
    id: 'ari_13',
    name: '아리',
    role: '회장',
    department: '소프트웨어학과',
    generation: 13,
    img: '/ari_13.png',
    github: 'https://github.com/mcy0325',
    rank: 'captain',
  },
  {
    id: 'beryl_13',
    name: '베릴',
    role: '부회장',
    department: '소프트웨어학과',
    generation: 13,
    img: '/beryl_13.png',
    github: 'https://github.com/MinJunKKang',
    rank: 'first-officer',
  },
  {
    id: 'jerry_13',
    name: '제리',
    role: '운영진',
    department: '소프트웨어학과',
    generation: 13,
    img: '/jerry_13.png',
    github: 'https://github.com/yyoonngg',
    rank: 'first-officer',
  },
  {
    id: 'leesajang_13',
    name: '이사장',
    role: '운영진',
    department: '소프트웨어학과',
    generation: 13,
    img: '/leesajang_13.png',
    github: 'https://github.com/girin-sj',
    rank: 'senior-crew',
  },
  {
    id: 'jyujyu_13',
    name: '쥬쥬',
    role: '운영진',
    department: '소프트웨어학과',
    generation: 13,
    img: '/jyujyu_13.png',
    github: 'https://github.com/JuJu-0225',
    rank: 'senior-crew',
  },
  {
    id: 'yaan_13',
    name: '얀',
    role: '운영진',
    department: '소프트웨어학과',
    generation: 13,
    img: '/yaan_13.png',
    github: 'https://github.com/yaaan7',
    rank: 'senior-crew',
  },
];

export const management14th = [
  {
    "id": "yaan_14",
    "name": "얀",
    "role": "회장",
    "department": "소프트웨어학과",
    "generation": 14,
    "img": "/yaan_14.png",
    "github": "https://github.com/yaaan7",
    "rank": "captain"
  },
  {
    "id": "nana_14",
    "name": "나나",
    "role": "부회장",
    "department": "소프트웨어학과",
    "generation": 14,
    "img": "/nana_14.png",
    "github": "https://github.com/kimyena123",
    "rank": "first-officer"
  },
  {
    "id": "jimal_14",
    "name": "지말",
    "role": "운영진",
    "department": "소프트웨어학과",
    "generation": 14,
    "img": "/jimal_14.png",
    "github": "https://github.com/qkwltkwkd1",
    "rank": "senior-crew"
  },
  {
    "id": "coda_14",
    "name": "코다",
    "role": "운영진",
    "department": "소프트웨어학과",
    "generation": 14,
    "img": "/coda_14.png",
    "github": "https://github.com/selnem",
    "rank": "senior-crew"
  },
  {
    "id": "dylan_14",
    "name": "딜런",
    "role": "운영진",
    "department": "소프트웨어학과",
    "generation": 14,
    "img": "/dylan_14.png",
    "github": "https://github.com/dh1180",
    "rank": "senior-crew"
  }
];

export const getAllManagement = () => [...management12th, ...management13th, ...management14th];
export const getManagementByGeneration = (gen) =>
  getAllManagement().filter(person => person.generation === gen);
